/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {
  HeaderUserMenu,
  ThemeModeSwitcher,
} from '../../../partials'
import {useAuth} from '../../../../app/modules/auth'
import {useNavigate} from 'react-router-dom'
import {useThemeMode} from '../../../partials/layout/theme-mode/ThemeModeProvider'
import {Modal} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import {useIntl} from 'react-intl'
import { setIsThereNonSavedForm } from '../../../../app/common/ModalPopup/reducer'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40p',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px'
  // toolbarButtonIconSizeClass = 'fs-1'

type TPProps = {onSearchClick?: () => void}
const Topbar: FC<TPProps> = ({onSearchClick}) => {
  // const navigate = useNavigate()
  const {currentUser} = useAuth()
  const [imageProfile, setImageProfile] = useState<string>()
  const {mode} = useThemeMode()
  const isThereNonSavedForm = useSelector((state: any) => state?.isThereNonSavedForm)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const [w2go, setW2go] = useState<string>('')
  const navigate = useNavigate()
  const intl = useIntl()
  const dispatch = useDispatch()
  
  const checkEditNonSaved = (e: any, routeName: string) => {
    setW2go(routeName)
    if (isThereNonSavedForm === true) {
      setShowCancel(true)
    } else {
      navigate(routeName, {replace: true})
    }
  }

  const onCancelReset = () => {
    setShowCancel(false)
  }

  const onConfirmCancel = () => {
    setShowCancel(false)
    dispatch(setIsThereNonSavedForm(false));
    navigate(w2go, {replace: true})
  }

  useEffect(() => {
    if (currentUser?.Photo) {
      setImageProfile(`${currentUser.Photo}`)
    } else {
      setImageProfile(toAbsoluteUrl('/media/avatars/blank.png'))
    }
  }, [currentUser])
  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      <div className='topbar d-flex align-items-stretch flex-shrink-0'>
        <div
          className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}
          style={{marginRight: 10}}
        >
          {/* <Search onSearchClick={onSearchClick} /> */}
          <div
            style={{transform: 'scale(1.5)'}}
            className='btn btn-icon btn-active-light-primary btn-custom w-30px h-30px w-md-40px h-md-40px '
            onClick={(e) => {
              e.preventDefault()
              checkEditNonSaved(e, '/home?s=focus&t=' + (Math.random() * 1000).toFixed(2))
            }}
          >
            <KTIcon iconName='magnifier' className='fs-1' />
          </div>
        </div>
        <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
          <ThemeModeSwitcher toggleBtnClass={toolbarButtonHeightClass} />
        </div>
        <div
          className={clsx('d-flex align-items-center fs-2x', toolbarButtonMarginClass)}
          id='kt_header_user_menu_toggle'
        >
          <div
            className={clsx(
              'cursor-pointer symbol d-flex align-items-center',
              toolbarUserAvatarHeightClass
            )}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <div
              className={clsx(
                'text-white user-name fw-900 fs-4 me-3 d-none d-sm-none d-lg-flex d-md-flex d-xl-flex '
              )}
            >
              {currentUser?.FirstName} {currentUser?.LastName} ({currentUser?.Profile})
            </div>
            <img
              className='h-30px w-30px rounded-circle'
              src={imageProfile}
              alt={currentUser?.FirstName}
            />
          </div>
          <HeaderUserMenu />
        </div>
      </div>
      <Modal show={showCancel} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button className={'btn btn-secondary'} onClick={onCancelReset}>
                {intl.formatMessage({id: 'NO'})}
              </button>
              <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                {intl.formatMessage({id: 'YES'})}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export {Topbar}
